import { Check, Clapperboard } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/v2/components/ui/dropdown-menu";
import { WHIZZARD_TYPE_LABEL, type WhizzardTypeFilter } from "../useWhizzards";
import { FilterTrigger } from "./FilterTrigger";

interface Props {
  value: WhizzardTypeFilter;
  onChange: (next: WhizzardTypeFilter) => void;
}

/** The Whizzards tab's type filter, built like ChannelFilterDropdown. */
export function WhizzardTypeDropdown({ value, onChange }: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <FilterTrigger icon={Clapperboard} label={WHIZZARD_TYPE_LABEL[value]} aria-label="Highlight type" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" style={{ minWidth: 200 }}>
        <div style={{ padding: "4px 8px" }}>
          <span className="text-xs font-semibold tracking-wide text-muted-foreground">TYPE</span>
        </div>
        <DropdownMenuRadioGroup value={value} onValueChange={(next) => onChange(next as WhizzardTypeFilter)}>
          {(Object.keys(WHIZZARD_TYPE_LABEL) as WhizzardTypeFilter[]).map((key) => (
            <DropdownMenuRadioItem
              key={key}
              value={key}
              // The radio dot sits in the item's left padding, which
              // Tailwind cannot set inside .v2; draw a check at the end.
              className="[&>span:first-child]:hidden"
              style={{ padding: "6px 8px", justifyContent: "space-between" }}
            >
              {WHIZZARD_TYPE_LABEL[key]}
              {key === value ? <Check size={14} className="text-action" /> : null}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
